import { memo } from 'react';
import css from './PageTitle.module.css';

const PageTitle = ({ title }) => {
  return <div className={css.title}>{title ?? ''}</div>;
};

export default memo(PageTitle);
